"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Heading = exports.Paragraph = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const typography_module_scss_1 = __importDefault(require("./typography.module.scss"));
const Paragraph = (_a) => {
    var { size = "default", weight = "normal", className = "", children } = _a, props = __rest(_a, ["size", "weight", "className", "children"]);
    return (react_1.default.createElement("p", Object.assign({ className: `${typography_module_scss_1.default.paragraph} ${className}`, "data-size": size, "data-weight": weight }, props), children));
};
exports.Paragraph = Paragraph;
const Heading = (_a) => {
    var { type = "h1", font = "metropolis", variation = font === "united" ? "display" : "default", className = "", children } = _a, props = __rest(_a, ["type", "font", "variation", "className", "children"]);
    const newClasses = (0, classnames_1.default)(`${typography_module_scss_1.default.heading} ${className}`);
    const newProps = Object.assign({ "data-font": font, "data-variation": variation }, props);
    return (0, react_1.createElement)(type, Object.assign({ className: newClasses }, newProps), children);
};
exports.Heading = Heading;
const Label = (_a) => {
    var { size = "default", className = "", children } = _a, props = __rest(_a, ["size", "className", "children"]);
    return (react_1.default.createElement("span", Object.assign({ "data-size": size, className: `${typography_module_scss_1.default.label} ${className}` }, props), children));
};
exports.Label = Label;
//# sourceMappingURL=typography.js.map